import React from 'react'
import { useMainPageSectionHeaderStyles } from './main-page-section-header.styles'

export type MainPageSectionHeaderProps = {
  /** Copy for the section `<h2>` (or pass a node for rich text). */
  title: React.ReactNode
  /** Optional supporting line under the title. */
  subtitle?: React.ReactNode
  /** Must match the parent `<section aria-labelledby="…">`. */
  titleId: string
  /** Optional control(s) aligned on the same row as the heading block (e.g. “See all”). */
  action?: React.ReactNode
  className?: string
}

export const MainPageSectionHeader: React.FC<MainPageSectionHeaderProps> = ({
  title,
  subtitle,
  titleId,
  action,
  className,
}) => {
  const classes = useMainPageSectionHeaderStyles()
  const rootClass = [classes.root, className].filter(Boolean).join(' ')

  return (
    <header className={rootClass}>
      <div className={classes.textColumn}>
        <h2 className={classes.title} id={titleId}>
          {title}
        </h2>
        {subtitle != null && subtitle !== '' ? (
          <p className={classes.subtitle}>{subtitle}</p>
        ) : null}
      </div>
      {action != null ? (
        <div className={classes.actions}>{action}</div>
      ) : null}
    </header>
  )
}
